import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CloseIcon } from '@yme/assets/icons';
import { Image } from '@yme/atoms/image';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { Tooltip, TooltipPlacement } from '@yme/atoms/tooltip';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
import { getImageSrc } from '@yme/utils/common';
import { AspectRatio, ImageSuffix } from '@yme/utils/constants';
import { formatPrice } from '@yme/utils/formatPrice';
import { CompareProductCardStyled, ImageWrapperStyled, FlexWrapperStyled } from './styled';
export function CompareProductCard({ productKey, image, title, price, isShowImage, language, className, hasTooltipTitle = false, handleRemoveProduct, }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onClick = useCallback((event) => {
        event.preventDefault();
        dispatch(setIsModalShowed({
            type: MODALS.COMPARISON_REMOVE_MODEL_MODAL,
            data: {
                title: t('comparison_removeModelPopUp_header'),
                description: t('comparison_removeModelPopUp_description'),
                primaryButtonContent: t('common_remove_button'),
                secondaryButtonContent: t('common_cancel_button'),
                primaryButtonHandler: () => handleRemoveProduct(productKey),
            },
        }));
    }, [dispatch, handleRemoveProduct, productKey, t]);
    const formattedPrice = formatPrice({
        locale: language,
        currencyName: price?.currencyCode,
        price: price?.amount,
    });
    return (React.createElement(CompareProductCardStyled, { gap: "8px", alignItems: "center", className: className },
        isShowImage && (React.createElement(ImageWrapperStyled, null,
            React.createElement(Image, { src: getImageSrc(image, ImageSuffix.Mobile), aspectRatio: AspectRatio.RectangleLevel6, errorPlaceholderHasBackground: false }))),
        React.createElement(FlexWrapperStyled, { flexDirection: "column", isFullWidth: true },
            React.createElement(FlexWrapper, { gap: "4px", justifyContent: "space-between" },
                React.createElement(Tooltip, { title: title, placement: TooltipPlacement.ABOVE_LEFT, hasEnableHoverListener: hasTooltipTitle },
                    React.createElement(RegularTextLevel3, { weight: 500, isEllipsisEndingLine: true }, title)),
                React.createElement(SVGIcon, { type: CloseIcon, size: ICON_SIZE.s, onClick: onClick, "aria-label": t('common_cancel_button') })),
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, formattedPrice ? `${t('common_from_label')} ${formattedPrice}` : React.createElement("span", null, "\u00A0")))));
}
